import React, { useEffect, useCallback, useState } from "react";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { api } from "../../../../../utility/AxiosInceptor";
import { Column } from "primereact/column";
import { DateTime } from "luxon";
import moment from "moment";
import { debounce } from "lodash";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import {
  DownloadIcon,
  NextIcon,
  PrevIcon,
  EmptyEnrollment,
  Postpaid,
} from "../../../../../utility";
import CommonLoaderBlue from "../../billingModel/billingmodel_configurations/Loaders/components/Loader/LoaderBlue";
const listLimit = 18;

const rowClick = true;
const Postpaid_Completed_Enrollments = () => {
  // State For Select Row
  const statusFiltersSelected = {
    prospectchecked: false,
    cancelchecked: false,
    all: false,
  };
  const [isFirstTimeCalledApi, setIsFirstTimeCalledApi] = useState(false);
  const [currentPagination, setCurrentPagination] = useState({});
  const [floatPagesLeft, setFloatPagesLeft] = useState([]);
  const [floatPagesRight, setFloatPagesRight] = useState([]);

  const [isExportLoading, setIsExportLoading] = useState(false);
  const [secondTimeCalled, setSecondTimeCalled] = useState(false);

  const [selectedEnrollments, setSelectedEnrollments] = useState(null);
  const [allCompletedEnrollments, setAllCompletedEnrollments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [customerSearchName, setCustomerSearchName] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const selectedRange = [null, null];

  const userData = JSON.parse(localStorage.getItem("userData"));
  const role = userData?.role?.role;
  const navigate = useNavigate();
  const handleEnrollmentIdClick = (rowData) => {
    localStorage.setItem("selectedId", JSON.stringify(rowData._id));

    navigate("/customer-profile", { state: { selectedId: rowData._id } });
  };
  const loginRes = localStorage.getItem("userData");
  const parseLoginRes = JSON.parse(loginRes);
  useEffect(() => {
    setCurrentPage(1);
  }, [customerSearchName]);
  const getAllCompletedEnrollments = useCallback(
    debounce(async () => {
      let status = [];
      if (statusFiltersSelected.prospectchecked) {
        status.push("prospect");
      }
      if (statusFiltersSelected.cancelchecked) {
        status.push("cancelled");
      }
      status = status.join(",");
      try {
        const res = await api.get(
          `/api/user/prePostCompletedEnrollmentsList?userId=${
            parseLoginRes?._id
          }&status=${status}&endDate=${
            selectedRange[1]
              ? moment(new Date(selectedRange[1])).format("MM-DD-YYYY")
              : ""
          }&startDate=${
            selectedRange[0]
              ? moment(new Date(selectedRange[0])).format("MM-DD-YYYY")
              : ""
          }&search=${customerSearchName}&page=${currentPage}&limit=${listLimit}&accountType=Postpaid`,
        );
        if (res?.status === 200 || res?.status === 201) {
          const updatedData = res?.data?.data.map((item) => ({
            ...item,
            enrollment: item.isSelfEnrollment
              ? "Self Enrollments"
              : "Enrollment",
            name: `${item?.firstName ? item?.firstName.toUpperCase() : ""} ${
              item?.lastName ? item?.lastName.toUpperCase() : ""
            }`,
            createdDate: new Date(item.createdAt)
              .toLocaleDateString("en-US", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
              })
              .replace(/\//g, "-"),
            createdFilter: DateTime.fromFormat(
              item.createdAt,
              "d LLL yyyy, h:mm a",
              { zone: "America/New_York" },
            ).toSeconds(),
            createdTo: DateTime.fromFormat(
              item.createdAt,
              "d LLL yyyy, h:mm a",
              { zone: "America/New_York" },
            ).toSeconds(),
          }));
          let totalPages = Math.ceil(
            (res?.data?.total ?? 0) / (listLimit ?? 1), // avoid division by 0
          );
          setCurrentPagination({
            total: res?.data?.total ?? 0,
            limit: listLimit ?? 0,
            page: res?.data?.page ?? 1,
            totalPages: totalPages,
          });

          if (totalPages > 6) {
            if (
              floatPagesLeft.length === 0 ||
              totalPages !== currentPagination.totalPages
            ) {
              setFloatPagesLeft([1, 2, 3]);
              setFloatPagesRight([totalPages - 1, totalPages]);
            }
          }
          setAllCompletedEnrollments(updatedData); // Initially display first 15 records
          if (isFirstTimeCalledApi) {
            setSecondTimeCalled(true);
          }
          setIsFirstTimeCalledApi(true);
          setTimeout(() => {
            setIsLoading(false);
          }, 500);
        }
      } catch (error) {
        if (isFirstTimeCalledApi) {
          setSecondTimeCalled(true);
        }
        setCurrentPagination({
          total: 0,
          limit: 0,
          page: 0,
          totalPages: 0,
        });
        setAllCompletedEnrollments([]);
        if (!secondTimeCalled) {
          toast.error(` ${error?.response?.data?.msg}`);
        }
        setIsLoading(false);
        setIsFirstTimeCalledApi(true);
      }
    }, 500),
    [currentPage, customerSearchName],
  );
  useEffect(() => {
    getAllCompletedEnrollments();
    return () => getAllCompletedEnrollments.cancel();
  }, [getAllCompletedEnrollments]);
  return (
    <div className="prepaidcompleted ">
      <ToastContainer />
      <div className="flex w-full flex-column justify-content-start h-4">
        <div className="prepaidsimslogo w-full">
          <span>
            <Postpaid />
          </span>
          <h6>Postpaid Connections</h6>
        </div>
        <h3 className="heading" style={{ marginTop: ".6rem" }}>
          Completed Enrollments
        </h3>
        <p className="para" style={{ marginTop: "1.2rem" }}>
          View and manage all enrollments with Active, Suspended, or
          Disconnected statuses in one organized table.{" "}
        </p>
        <div
          className="flex flex-wrap justify-content-start align-items-center w-full"
          style={{ marginTop: "2.4rem", height: "4rem" }}
        >
          <div className="flex flex-wrap w-full justify-content-between align-items-center">
            <div className="flex prosp">
              <h2 className="prosp-heading">Active / Suspended / Disconnect</h2>
            </div>
            {allCompletedEnrollments &&
              !isLoading &&
              allCompletedEnrollments?.length > 0 && (
                <div
                  className="flex  justify-content-end align-items-center"
                  style={{ width: "50.5rem", gap: "1.6rem" }}
                >
                  <InputText
                    className="searchbar"
                    value={customerSearchName}
                    onChange={(e) => setCustomerSearchName(e.target.value)}
                    placeholder="ID, Name, Contact, Date"
                  />

                  <div>
                    <button
                      onClick={async () => {
                        setIsExportLoading(true);
                        let status = [];
                        if (statusFiltersSelected.prospectchecked) {
                          status.push("prospect");
                        }
                        if (statusFiltersSelected.cancelchecked) {
                          status.push("cancelled");
                        }
                        status = status.join(",");
                        api
                          .get(
                            `/api/user/prePostCompletedEnrollmentsList?userId=${
                              parseLoginRes?._id
                            }&exportCustomer=true&status=${status}&endDate=${
                              selectedRange[1]
                                ? moment(new Date(selectedRange[1])).format(
                                    "MM-DD-YYYY",
                                  )
                                : ""
                            }&startDate=${
                              selectedRange[0]
                                ? moment(new Date(selectedRange[0])).format(
                                    "MM-DD-YYYY",
                                  )
                                : ""
                            }&search=${customerSearchName}&page=${currentPage}&limit=${listLimit}&accountType=Postpaid`,
                            { responseType: "blob" },
                          )
                          .then((response) => {
                            const contentDisposition =
                              response.headers["content-disposition"];
                            let filename =
                              "Postpaid_CompletedEnrollments_CustomerData.xlsx";
                            if (contentDisposition) {
                              const match = contentDisposition.match(
                                /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/,
                              );
                              if (match) {
                                filename = decodeURIComponent(
                                  match[1] || match[2],
                                );
                              }
                            }

                            const blob = new Blob([response.data], {
                              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                            });

                            const url = window.URL.createObjectURL(blob);
                            const a = document.createElement("a");
                            a.href = url;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                            window.URL.revokeObjectURL(url);
                            document.body.removeChild(a);

                            setIsExportLoading(false);
                          });
                      }}
                      className="export backbtn flex justify-content-center align-items-center"
                    >
                      {!isExportLoading ? (
                        <div
                          className="flex flex-wrap flex-row justify-content-start"
                          style={{
                            marginTop: "-0.4rem",
                            height: "1.6rem",
                            width: "6.9rem",
                            gap: "0.4rem",
                          }}
                        >
                          <p
                            style={{
                              padding: "0rem",
                              fontWeight: 500,
                              fontSize: "1.4rem",
                              margin: "0rem",
                            }}
                          >
                            Export
                          </p>
                          <div
                            style={{ marginTop: "0.3rem", marginLeft: "0rem" }}
                          >
                            <DownloadIcon />
                          </div>
                        </div>
                      ) : (
                        <div className="flex flex-wrap flex-row justify-content-center align-items-center">
                          <CommonLoaderBlue
                            color={"royalblue"}
                            customSize={14}
                          />
                        </div>
                      )}
                    </button>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
      {allCompletedEnrollments?.length === 0 &&
      !isLoading &&
      !secondTimeCalled ? (
        <div
          className="flex w-full  justify-content-center "
          style={{ marginTop: "5rem" }}
        >
          <div className="emptystatediv">
            <div className="emptyicon">
              <span>
                <EmptyEnrollment />
              </span>
            </div>
            <div className="emptystatedata">
              <h1>No Enrollments in the Queue!</h1>
              <p>
                There are currently no active, suspended, or disconnected
                enrollments to display. Start new enrollments to fill your
                queue!
              </p>
              <div className="flex w-full justify-content-center">
                <Button
                  className="emptystatebtn"
                  label="Start Enrollment"
                  onClick={() => navigate("/postpaid-newenrollment")}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          className={
            role === "Admin"
              ? "completedenrolltableadmin"
              : "completedenrolltable"
          }
          style={{ marginTop: "2.4rem" }}
        >
          <DataTable
            selectionMode={rowClick ? null : "checkbox"}
            selection={selectedEnrollments}
            onSelectionChange={
              role !== "Admin" ? null : (e) => setSelectedEnrollments(e.value)
            }
            value={allCompletedEnrollments}
            emptyMessage={
              isLoading ? (
                <div
                  style={{ width: "108.4rem" }}
                  className="flex p-2 flex-wrap flex-row justify-content-center align-items-center "
                >
                  <CommonLoaderBlue customSize={14} />
                </div>
              ) : (
                ""
              )
            }
            globalFilterFields={["enrollmentId", "name"]}
            stripedRows
            size="small"
            onRowClick={(e) => handleEnrollmentIdClick(e.data)}
            // emptyMessage={
            //     isLoading ? (
            //         <div className="flex flex-wrap w-full justify-content-center  flex-row  mt-4 mb-4 ">
            //             <CommonLoaderBlue customSize={16} />
            //         </div>
            //     ) : (
            //         "Enrollment Not Found"
            //     )
            // }
          >
            <Column
              selectionMode="multiple"
              style={{
                pointerEvents: role !== "Admin" ? "none" : "auto",
                opacity: role !== "Admin" ? 0.5 : 1,
              }}
            />

            <Column
              header="Id"
              field="enrollmentId"
              // body={(rowData) => (
              //     <button style={{ fontSize: "1.272rem", fontWeight: "500", color: "#5E79FF", border: "none", backgroundColor: "transparent", cursor: "pointer" }} onClick={() => handleEnrollmentIdClick(rowData)}>
              //         {rowData.enrollmentId}
              //     </button>
              // )}
            ></Column>
            <Column
              header="Link Acc"
              body={(rowData) => {
                return (
                  <p className={rowData?.linkedAccount ? "yes" : "no"}>
                    {rowData?.linkedAccount ? "Yes" : "No"}
                  </p>
                );
              }}
            />
            <Column header="Name" field="name"></Column>
            <Column field="contact" header="Contact" />
            <Column
              header="Status"
              body={(rowData) => (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                  }}
                >
                  <span
                    style={{
                      color:
                        rowData?.status === "prospect"
                          ? "#4A90E2"
                          : rowData?.status === "cancelled"
                            ? "#95A5A6"
                            : rowData?.status === "active"
                              ? "#27AE60"
                              : rowData?.status === "disconnected"
                                ? "#B3261E"
                                : rowData?.status === "inactive"
                                  ? "#B3261E"
                                  : rowData?.status === "suspended"
                                    ? "#F39C12"
                                    : "",
                      fontSize: "1.4rem",
                      textTransform: "capitalize",
                    }}
                  >
                    {rowData?.status
                      ? rowData.status.charAt(0).toUpperCase() +
                        rowData.status.slice(1).toLowerCase()
                      : ""}
                  </span>
                </div>
              )}
            />
            {role === "Admin" && (
              <Column field="createdBy.name" header="Created By" />
            )}
            <Column field="createdDate" header="Date" />
            {/* <Column
                        header="Linked"
                        body={(rowData) => {
                            return <p className={rowData?.linkedAccount ? "yes" : "no"}>{rowData?.linkedAccount ? "Yes" : "No"}</p>;
                        }}
                    />
                    <Column header="Actions" body={actionTemplate}></Column> */}
          </DataTable>
          <div
            style={{ marginTop: "2.4rem" }}
            className="flex flex-wrap w-full  flex-row justify-content-between align-items-center "
          >
            {isFirstTimeCalledApi && (
              <h1 className="infoenrollmentsall">
                {currentPagination?.total
                  ? currentPagination?.page * currentPagination.limit >
                    currentPagination.total
                    ? currentPagination.total
                    : currentPagination?.page * currentPagination.limit
                  : "0"}
                /{currentPagination?.total ? currentPagination?.total : "0"}
              </h1>
            )}
            {currentPagination?.totalPages > 1 && isFirstTimeCalledApi && (
              <div className="flex flex flex-wrap flex-row justify-content-between pages">
                <button
                  disabled={currentPage === 1}
                  onClick={() => {
                    let pagetocheck = currentPage;
                    pagetocheck--;
                    if (currentPagination.totalPages <= 6 && pagetocheck > 0) {
                      setCurrentPage(pagetocheck);
                    } else if (
                      floatPagesLeft.includes(pagetocheck) ||
                      floatPagesRight.includes(pagetocheck)
                    ) {
                      setCurrentPage(pagetocheck);
                    } else if (pagetocheck > 0) {
                      if (pagetocheck === floatPagesLeft[0] - 1) {
                        let arr = floatPagesLeft;

                        arr.pop();
                        arr.unshift(floatPagesLeft[0] - 1);
                        setFloatPagesLeft(arr);
                        setCurrentPage(pagetocheck);
                      } else if (pagetocheck === floatPagesRight[0] - 1) {
                        let arr = floatPagesRight;

                        arr.pop();
                        arr.unshift(floatPagesRight[0] - 1);
                        setFloatPagesRight(arr);
                        setCurrentPage(pagetocheck);
                      }
                    }
                  }}
                  className="cursor-pointer backbtn"
                  style={{
                    fontSize: "1.4rem",
                    fontWeight: "500",
                    opacity: currentPage === 1 && "0.6",
                    backgroundColor: "#FFFFFF33",
                    width: "10.6rem",
                    height: "3.8rem",
                    margin: "0rem",
                  }}
                >
                  <span>
                    <PrevIcon /> &nbsp; Previous
                  </span>
                </button>
                <div
                  style={{ maxWidth: "26.9rem", gap: "1rem" }}
                  className="flex flex-wrap flex-row justify-content-start align-items-start"
                >
                  {currentPagination.totalPages <= 6 ? (
                    [...Array(currentPagination.totalPages)].map((_, index) => (
                      <Button
                        onClick={() => {
                          setCurrentPage(index + 1);
                        }}
                        style={{ width: "3.1rem", height: "3.4rem" }}
                        key={index + 1}
                        className={
                          currentPagination.page === index + 1
                            ? "pagecounteractive"
                            : "pagecounter"
                        }
                        label={index + 1}
                      />
                    ))
                  ) : (
                    <>
                      {floatPagesLeft.map((page) => (
                        <Button
                          key={page}
                          onClick={() => {
                            setCurrentPage(page);
                          }}
                          style={{ width: "3.1rem", height: "3.4rem" }}
                          className={
                            currentPagination.page === page
                              ? "pagecounteractive"
                              : "pagecounter"
                          }
                          label={page}
                        />
                      ))}
                      {floatPagesLeft[floatPagesLeft.length - 1] + 1 !==
                        floatPagesRight[0] && (
                        <Button className="pagecounter" label={"..."} />
                      )}

                      {floatPagesRight.map((page) => (
                        <Button
                          onClick={() => {
                            setCurrentPage(page);
                          }}
                          key={page}
                          className={
                            currentPagination.page === page
                              ? "pagecounteractive"
                              : "pagecounter"
                          }
                          label={page}
                        />
                      ))}
                    </>
                  )}
                </div>
                <button
                  disabled={currentPage === currentPagination.totalPages}
                  onClick={() => {
                    let pagetocheck = currentPage;
                    pagetocheck++;
                    if (
                      currentPagination.totalPages <= 6 &&
                      pagetocheck > 0 &&
                      pagetocheck <= currentPagination.totalPages
                    ) {
                      setCurrentPage(pagetocheck);
                    } else if (
                      floatPagesLeft.includes(pagetocheck) ||
                      floatPagesRight.includes(pagetocheck)
                    ) {
                      setCurrentPage(pagetocheck);
                    } else if (pagetocheck <= currentPagination.totalPages) {
                      if (
                        pagetocheck ===
                        floatPagesLeft[floatPagesLeft.length - 1] + 1
                      ) {
                        let arr = floatPagesLeft;

                        arr.shift();
                        arr.push(pagetocheck);
                        setFloatPagesLeft(arr);
                        setCurrentPage(pagetocheck);
                      } else {
                        if (
                          pagetocheck ===
                            floatPagesRight[floatPagesRight.length - 1] + 1 &&
                          pagetocheck <= currentPagination.totalPages
                        ) {
                          let arr = floatPagesRight;

                          arr.shift();
                          arr.push(pagetocheck);
                          setFloatPagesRight(arr);
                          setCurrentPage(pagetocheck);
                        }
                      }
                    }
                  }}
                  className="cursor-pointer backbtn"
                  style={{
                    fontSize: "1.4rem",
                    fontWeight: "500",
                    opacity:
                      currentPage === currentPagination.totalPages && "0.6",
                    backgroundColor: "#FFFFFF33",
                    width: "8rem",
                    height: "3.8rem",
                  }}
                >
                  <span className="flex align-items-center">
                    Next &nbsp;
                    <NextIcon />
                  </span>
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      <br />
    </div>
  );
};

export default Postpaid_Completed_Enrollments;
